import React from 'react';
import { useTranslation } from 'localization';
import { useAnalytics } from '@center-technologies/analytics';
import { SegmentedControlAtom, SegmentedControlOption } from 'design-system/my-lib';
import { useStudioMode, StudioMode } from './StudioMode';

/** Topbar mode switcher (spec SC8) — a `SegmentedControlAtom` over the three modes, per the Reuse
 * Audit. Writes the preference through `useStudioMode` and fires `studio_mode_changed`, the
 * event's documented source. */
const StudioModePill: React.FC = () => {
  const { t } = useTranslation();
  const logAnalyticsEvent = useAnalytics();
  const { mode, setMode } = useStudioMode();

  const options: SegmentedControlOption<StudioMode>[] = [
    { value: 'platform', label: t('studio.mode.platform') },
    { value: 'operator', label: t('studio.mode.operator') },
    { value: 'author', label: t('studio.mode.author') },
  ];

  const handleChange = (next: StudioMode | StudioMode[]) => {
    const value = Array.isArray(next) ? next[0] : next;
    if (!value || value === mode) return;
    const from = mode;
    setMode(value);
    logAnalyticsEvent('studio_mode_changed', undefined, { from, to: value, source: 'pill' });
  };

  return (
    <SegmentedControlAtom
      options={options}
      value={mode}
      onChange={handleChange}
      mode="single"
      size="small"
      ariaLabel={t('studio.mode.pillLabel')}
      data-testid="studio-mode-pill"
    />
  );
};

export default StudioModePill;
